import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["kk", "ru", "en"],
    fallbackLng: "kk",
    load: "languageOnly",
    ns: ["common"],
    defaultNS: "common",

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },

    detection: {
      order: ["cookie", "localStorage", "queryString"],
      caches: ["localStorage", "cookie"],
      lookupCookie: "i18next_lng",
      lookupLocalStorage: "i18next_lng",
      cookieOptions: {
        path: "/",
        sameSite: "lax",
        secure: true,
      },
    },

    react: {
      useSuspense: false,
    },

    interpolation: {
      escapeValue: false,
    },

    debug: false,

    nonExplicitSupportedLngs: false,
  });

export default i18n;